'use strict';

function ResetPasswordCtrl($scope, translations, $state, config, $window, $http, $translate, growl) {
  $scope.resetPassword = function(email) {
    var data = {Email: email};
    $http({
      method: 'POST',
      url: config.apiBase + '/users/forgot-password',
      data: data
    })
    .success(function() {
      growl.addSuccessMessage(translations['user.request-password-reset-success']);
      window.location.href = '/login';
    })
    .error(function() {
      growl.addErrorMessage(translations['user.request-password-reset-failure']);
    });
  };

  $scope.availableLanguages = [
    {value: "en", label: "English"},
    {value: "se", label: "Svenska"}
  ];

  $scope.lang = {
    selectedLanguage: $translate.use()
  };

  $scope.switchLanguage = function(langKey) {
    $translate.use(langKey);
  };
}

ResetPasswordCtrl.resolve = {
  translations: ['$translate', function($translate) {
    return $translate([
      'user.request-password-reset-success',
      'user.request-password-reset-failure'
    ]);
  }]
};
module.exports = ResetPasswordCtrl;

angular.module('dokiv')
  .controller('ResetPasswordCtrl', ['$scope', 'translations', '$state', 'config', '$window', '$http', '$translate', 'growl', ResetPasswordCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/auth/ResetPasswordCtrl.js
// module id = 277
// module chunks = 0